module.exports = __webpack_public_path__ + "static/media/company-02.86219de1.jpg";